import { render, staticRenderFns } from "./ProductPageWebMarker.vue?vue&type=template&id=2030a7b2&scoped=true&"
import script from "./ProductPageWebMarker.vue?vue&type=script&lang=js&"
export * from "./ProductPageWebMarker.vue?vue&type=script&lang=js&"
import style0 from "./ProductPageWebMarker.vue?vue&type=style&index=0&id=2030a7b2&scoped=true&lang=css&"
import style1 from "./ProductPageWebMarker.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2030a7b2",
  null
  
)

export default component.exports